import moment from "moment";
import React, { useState } from 'react';
import { FaCalendarAlt, FaCouch, FaFileAlt, FaHome, FaImage, FaMoneyBillWave, FaUser } from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import { circleDownArrow, viewIcon } from "../../../assets";
import { ClientsPanelHeader, CustomText } from '../../../common/custom';
import CustomContainer from '../../../common/custom/CustomContainer';
import PreviewFullImageModal from "../../../common/custom/Modals/PreviewFullImage/modal";
import { CustomIcon } from "../../../common/customAssets";



const ViewDeatilLeaseProtection = () => {
    const { state: data } = useLocation();
    const [openViewContractModal, setOpenViewContractModal] = useState(false);
    const [contractFile, setContractFile] = useState({});

    const Tooltip = ({ children, content }) => {
        const [isVisible, setIsVisible] = useState(false)

        return (
            <div className="relative inline-block">
                <div onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
                    {children}
                </div>
                {isVisible && (
                    <div className="absolute z-10 w-64 p-2 mt-2 text-sm text-white bg-gray-800 rounded-lg shadow-lg">{content}</div>
                )}
            </div>
        )
    }

    const InfoSection = ({ title, data, icon: Icon }) => (
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
            <div className="bg-gradient-to-r from-[#77553D] to-[#C2A287] p-4 flex items-center">
                <div className="bg-white p-2 rounded-full mr-3">
                    <Icon className="text-[#77553D] text-xl" />
                </div>
                <h2 className="text-white text-lg font-semibold">{title}</h2>
            </div>
            <div className="p-4">
                {data.map((item, index) => (
                    <div key={index} className="flex justify-between py-2 border-b border-gray-200 last:border-b-0">
                        <span className={`text-[#6B7280] ${item?.largeText ? "text-xl" : "text-base"} font-medium`}>
                            {item.label}
                        </span>
                        {item.value && typeof item.value === "string" && item.value.length > 60 ? (
                            <Tooltip content={item.value}>
                                <span className="text-[#1F2937] text-base font-semibold truncate max-w-[150px]">
                                    {item.value.substring(0, 60)}...
                                </span>
                            </Tooltip>
                        ) : (
                            <span className={`text-[#1F2937] ${item?.largeText ? "text-xl" : "text-base"} font-semibold`}>
                                {item.value || "-"}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )

    const AttachmentItem = ({ url, index }) => {
        const fileName = url.split("/").pop()
        return (
            <div className="flex items-center justify-between py-4 border-b border-gray-200 last:border-b-0">
                <span className="text-[#6B7280] text-base font-medium">{fileName}</span>
                <div className="flex gap-3 items-center">
                    <div className={`flex items-center cursor-pointer`} onClick={() => { setOpenViewContractModal(true); setContractFile({ location: url }) }}>
                        <CustomIcon icon={viewIcon} />
                        <CustomText className="font-inter font-[500] ml-[3px]">View</CustomText>
                    </div>
                    <div className={`flex items-center cursor-pointer`} onClick={() => { window.open(url, '_blank') }}>
                        <CustomIcon icon={circleDownArrow} />
                        <CustomText className="font-inter font-[500] ml-[3px]">Download</CustomText>
                    </div>
                    {/* <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-800 text-base font-semibold underline"
                    >
                        Download Contract
                    </a>
                    <p onClick={() => { setOpenViewContractModal(true); setContractFile([{ location: url }]) }} className="text-blue-600 hover:text-blue-800 text-base font-semibold cursor-pointer underline">View Contract</p> */}
                </div>
            </div>
        )
    }

    const ImageGallery = ({ images }) => {
        if (!images || images.length === 0) return null

        return (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 p-2">
                {images.map((imageUrl, index) => (
                    <div
                        key={index}
                        className="relative overflow-hidden rounded-lg border border-gray-200 mx-auto"
                        style={{ width: "120px", height: "120px" }}
                    >
                        <img
                            src={imageUrl || "/placeholder.svg"}
                            alt={`Lease image ${index + 1}`}
                            className="object-cover w-full h-full hover:scale-105 transition-transform duration-300"
                            onClick={() => window.open(imageUrl, "_blank")}
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs p-1 text-center cursor-pointer">
                            Download
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(amount)
    }
    // Parse images
    let parsedImages = []
    try {
        if (data.images) {
            const imagesData = JSON.parse(data.images)
            if (Array.isArray(imagesData) && imagesData.length > 0) {
                parsedImages = imagesData?.flatMap(item => item)?.map((img) => img.location)
            }
        }
    } catch (error) {
        console.error("Error parsing images:", error)
    }

    // Parse coverage attachments if needed
    let parsedCoverageAttachments = []
    try {
        if (data.coverageAttachments) {
            const attachmentsData = JSON.parse(data.coverageAttachments)
            if (Array.isArray(attachmentsData) && attachmentsData.length > 0) {
                parsedCoverageAttachments = attachmentsData?.flatMap(item => item)?.map((att) => att.location)
            }
        }
    } catch (error) {
        console.error("Error parsing coverage attachments:", error)
    }

    const formatEventDates = (startDate, endDate) => {
        const start = moment(startDate)
        const end = moment(endDate)

        if (start.isSame(end, "month") && start.isSame(end, "year")) {
            return `${start.format("MMMM D")}–${end.format("D, YYYY")}`
        } else if (start.isSame(end, "year")) {
            return `${start.format("MMMM D")}–${end.format("MMMM D, YYYY")}`
        } else {
            return `${start.format("MMMM D, YYYY")}–${end.format("MMMM D, YYYY")}`
        }
    }

    return (
        <div>
            <CustomContainer>
                <ClientsPanelHeader />
                <div className="bg-gray-50 min-h-screen py-8">
                    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 pb-12">
                        <h1 className="text-[#1F2937] font-inter text-center text-3xl font-bold w-full mb-8">Lease Details</h1>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <InfoSection
                                title="Lease Information"
                                icon={FaFileAlt}
                                data={[
                                    { label: "Lease Number", value: data.leaseNo },
                                    {
                                        label: "Furniture Type",
                                        value: data.furnitureType
                                            ? data.furnitureType.charAt(0).toUpperCase() + data.furnitureType.slice(1)
                                            : "-",
                                    },
                                    { label: "Total Value", value: formatCurrency(data.totalValue) },
                                    { label: "Premium", value: formatCurrency(data.premium) },
                                ]}
                            />

                            <InfoSection
                                title="Customer Details"
                                icon={FaUser}
                                data={[
                                    { label: "Name", value: `${data.firstName} ${data.lastName}` },
                                    { label: "Email", value: data.email },
                                    { label: "Phone Number", value: data.phoneNumber },
                                ]}
                            />

                            <InfoSection
                                title="Address Information"
                                icon={FaHome}
                                data={[
                                    { label: "Property Address", value: data.address },
                                    { label: "Mailing Address", value: data.mailingAddress },
                                ]}
                            />

                            <InfoSection
                                title="Lease Period"
                                icon={FaCalendarAlt}
                                data={[
                                    {
                                        label: "Lease Dates",
                                        value: formatEventDates(data.startDate, data.endDate),
                                    },
                                    {
                                        label: "Start Date",
                                        value: moment(data.startDate).format("MM/DD/YYYY"),
                                    },
                                    {
                                        label: "End Date",
                                        value: moment(data.endDate).format("MM/DD/YYYY"),
                                    },
                                ]}
                            />
                        </div>

                        <div className="mt-6">
                            <InfoSection
                                title="Furniture Details"
                                icon={FaCouch}
                                data={[
                                    {
                                        label: "Furniture Type",
                                        value: data.furnitureType
                                            ? data.furnitureType.charAt(0).toUpperCase() + data.furnitureType.slice(1)
                                            : "-",
                                    },
                                    // { label: "Total Value", value: formatCurrency(data.totalValue) },
                                ]}
                            />
                        </div>

                        <div className="mt-6">
                            <InfoSection
                                title="Financial Information"
                                icon={FaMoneyBillWave}
                                data={[
                                    { label: "Total Value", value: formatCurrency(data.totalValue), largeText: true },
                                    { label: "Premium", value: formatCurrency(data.premium) },
                                ]}
                            />
                        </div>

                        {parsedCoverageAttachments && parsedCoverageAttachments.length > 0 && (
                            <div className="mt-6">
                                <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
                                    <div className="bg-gradient-to-r from-[#77553D] to-[#C2A287] p-4 flex items-center">
                                        <div className="bg-white p-2 rounded-full mr-3">
                                            <FaFileAlt className="text-[#77553D] text-xl" />
                                        </div>
                                        <h2 className="text-white text-lg font-semibold">Contract Attachments</h2>
                                    </div>
                                    <div className="p-4">
                                        {parsedCoverageAttachments.map((url, index) => (
                                            <AttachmentItem key={index} url={url} index={index} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {parsedImages.length > 0 && (
                            <div className="mt-6">
                                <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
                                    <div className="bg-gradient-to-r from-[#77553D] to-[#C2A287] p-4 flex items-center">
                                        <div className="bg-white p-2 rounded-full mr-3">
                                            <FaImage className="text-[#77553D] text-xl" />
                                        </div>
                                        <h2 className="text-white text-lg font-semibold">Images</h2>
                                    </div>
                                    <div className="p-4">
                                        <ImageGallery images={parsedImages} />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </CustomContainer>
            {openViewContractModal && <PreviewFullImageModal
                title='Veiw Contract'
                show={openViewContractModal}
                file={contractFile}
                onClose={() => setOpenViewContractModal(false)}
            />}
        </div>
    )
}

export default ViewDeatilLeaseProtection;